import React from 'react';
import { cn } from '../lib/utils';

interface XOVRLabelProps {
  className?: string;
  isX?: boolean;
}

export const XOVRLabel: React.FC<XOVRLabelProps> = ({ className, isX = true }) => {
  return (
    <span className={cn("inline-flex items-baseline", className)}>
      {isX && <span className="lowercase text-[0.75em]">x</span>}
      <span>OVR</span>
    </span>
  );
};
